<h2 mat-dialog-title>{{modalTitle | transloco:titleTranslationOptions}}</h2>
@if (form) {
  <mat-dialog-content class="pb-3">
    @if (modalSubTitle) {
      <p>{{modalSubTitle | transloco}}</p>
    }
    <loren-entity-form
      #entityForm
      [formModel]="form"
      (submitForm)="handleSubmitForm($event)"
      (formFieldInteraction)="handleFormFieldInteraction($event)">
    </loren-entity-form>
    @if (form.hasGlobalFormError) {
      <div class="mat-error">
        {{form.hasGlobalFormErrorMsg | transloco}}
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>{{modalCloseBtnLabel | transloco}}</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-button [color]="modalAcceptBtnColor" [mat-dialog-close]="true" [disabled]="form.hasGlobalFormError" (click)="entityForm.onSubmit()">
      {{modalAcceptBtnLabel | transloco}}
    </button>
  </mat-dialog-actions>
}
@if (!form) {
  <mat-dialog-content class="pb-3">
    @if (modalSubTitle) {
      <p>{{modalSubTitle | transloco}}</p>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>{{modalCloseBtnLabel | transloco}}</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-button [color]="modalAcceptBtnColor" [mat-dialog-close]="true">
      {{modalAcceptBtnLabel | transloco}}
    </button>
  </mat-dialog-actions>
}
